<template>
	<div>
		<v-row>
			<v-col md="9" class="px-md-4 py-md-1">
				<v-autocomplete
					clearable
					hide-selected
					:items="availableTariffs"
					item-text="name"
					v-model="search"
					label="Tarifa"
					@change="updateTariff()"
				>
					<template #selection="{ item }">
						<v-chip color="pink" class="white--text">
							{{ item }}
							<v-icon right> mdi-ticket </v-icon>
						</v-chip>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col md="3" class="px-md-4 py-md-1">
				<v-autocomplete
					clearable
					hide-selected
					:items="['PREPAGO', 'ALTA_NUEVA', 'PORTABILIDAD', 'RENUEVO']"
					v-model="searchType"
					label="Tipo de Installment"
					@change="updateTariff()"
				>
					<template #selection="{ item }">
						<v-chip color="green accent-3" class="black--text">
							{{ item }}
							<v-icon right color="black"> mdi-format-list-bulleted-type </v-icon>
						</v-chip>
					</template>
				</v-autocomplete>
			</v-col>
		</v-row>
		<v-row v-if="searchInstallments.length <= 0" class="d-flex justify-center pb-md-2 pt-12">
			<h1 class="font-weight-light grey--text">No existe un precio para el terminal con los filtros deseados</h1>
		</v-row>
		<v-row v-else class="pb-md-2" style="height: 320px; overflow-y: scroll">
			<v-col
				md="12"
				class="px-md-4 py-md-1"
				v-for="item in searchInstallments"
				:key="item.id"
			>
				<v-card outlined width="98%">
					<v-row class="pa-md-3 pl-md-16 mr-n10">
						<v-col
							md="3"
							class="d-flex flex-row align-center mr-md-16"
						>
							<v-icon
								class="mr-md-4"
								:color="tariffColor(item)"
								size="40"
								>mdi-cellphone</v-icon
							>
							<h3
								:class="
									'font-weight-light text-justify ' +
									tariffColor(item) +
									'--text'
								"
							>
								{{ item.tariff_name ? item.tariff_name : !item.initial_price && !item.final_price ? 'Todos' : '' }}
							</h3>
						</v-col>
						<v-col
							md="2"
							class="d-flex justify-center"
							style="background-color: rgb(253, 255, 149)"
						>
							<div class="d-flex flex-column align-self-center">
								<h2
									class="align-self-center font-weight-thin text-justify"
								>
									{{ item.installment_type }}
								</h2>						
								<h4
									class="align-self-center font-weight-thin text-justify"
								>
									{{ item.tariff_operator + " " + item.tariff_segment }}
								</h4>	
								<h5
									class="align-self-center font-weight-thin text-justify"
								>
									{{ item.tariff_type != 'Tarifa' ? 'Adicional' : 'Principal' }}
								</h5>	
							</div>
						</v-col>
						<v-col
							md="2"
							style="background-color: rgb(149, 255, 149)"
						>
							<div v-if="item.month_price" class="d-flex flex-row align-self-center">
								<h2
									class="
										display-3	
										black--text
										text-justify
										pt-md-2
									"
								>
									{{ item.month_price }}
								</h2>
								<div class="pt-md-2 mb-md-5">
									<small class="grey--text text-justify">{{
										"'" +
										(item.month_price % 1)
											.toFixed(2)
											.replace('0.', '')
									}}</small
									><small
										class="
											d-flex
											flex-column
											grey--text
											text-justify
										"
										>€/mes</small
									>
								</div>
							</div>
							<div v-else class="d-flex align-self-center">
								<h3
									class="
										display-3
										black--text
										text-justify
										pt-md-2
									"
								>
									{{ item.initial_price }}
								</h3>
								<div class="pt-md-2 mb-md-5">
									<small class="grey--text text-justify">{{
										"'" +
										(item.initial_price % 1)
											.toFixed(2)
											.replace('0.', '')
									}}</small
									><small
										class="
											d-flex
											flex-column
											grey--text
											text-justify
										"
										>€/mes</small
									>
								</div>
							</div>
						</v-col>
						<v-col md="3" style="margin-left: 120px">
							<v-row>
								<v-col md="5">
									<v-img
										:src="
											selectedDevice &&
											selectedDevice.devices[0]
												? selectedDevice.devices[0]
														.images[0].url
												: ''
										"
										contain
										height="100px"
										width="150px"
									></v-img>
								</v-col>
								<v-col md="7" class="d-flex justify-center align-self-center" v-if="!item.month_price && !item.final_price">
									<v-row>
										<v-col
											cols="12"
											class=""
										>
											<h3 class="align-self-center display-1 text-justify">
												{{ item.initial_price + ' €' }}
											</h3>
											<small class="grey--text text-justify">Pago Único</small>
										</v-col>
									</v-row>
								</v-col>
								<v-col md="7" v-else class="mt-md-n2">
									<div class="d-flex flex-row">
										<h3
											:class="
												'display-2 text-justify pt-md-2 ' +
												tariffColor(item) +
												'--text'
											"
										>
											{{ item.month_price }}
										</h3>
										<div class="pl-md-1 pt-md-2 mb-md-5">
											<small
												class="grey--text text-justify"
												>{{
													"'" +
													(item.month_price % 1)
														.toFixed(2)
														.replace('0.', '')
												}}
												€/mes</small
											><small
												class="
													d-flex
													flex-column
													grey--text
													text-justify
												"
												>{{
													item.time + ' plazos'
												}}</small
											>
										</div>
									</div>
									<div
										class="
											d-flex
											flex-column
											pl-md-1
											mt-md-n1
										"
									>
										<small
											class="grey--text text-justify"
											>{{
												'Pago Inicial: ' +
												item.initial_price +
												'€'
											}}</small
										><small
											class="grey--text text-justify"
											>{{
												'Pago Final: ' +
												item.final_price +
												'€'
											}}</small
										>
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'DeviceInstallment',
	data: () => ({
		search: '',
		searchType: '',
		searchInstallments: [],
		availableTariffs: [],
	}),
	computed: {
		...mapState('deviceManagement', {
			selectedDevice: (state) => state.selectedDevice,
			installment: (state) => state.installment,
		}),
	},
	methods: {
		tariffColor(inst){
			return inst.tarifa?.color ? inst.tarifa.color : ''
		},
		stripString(val) {
			if (typeof val !== 'string') return '';
			return val
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/\s/g, '');
		},
		updateTariff() {
			if (this.search != '' || this.searchType != ''){
				this.searchInstallments = this.installment.filter((item) =>{
					let filter_tariff = this.search == 'Único' ? item.tariff == null : this.stripString(item.tariff_name).includes(this.stripString(this.search))
					let filter_type = this.searchType ? item.installment_type == this.searchType : true

					return filter_tariff && filter_type
				});
			}
			else this.searchInstallments = this.installment;
		},
	},
	beforeCreate() {
		this.searchInstallments = this.installment;
	},
	created() {
		this.availableTariffs = this.installment.map((installment) =>{
			return installment.tariff_name ? installment.tariff_name : 'Único'
		});
		this.searchInstallments = this.installment;
	},
};
</script>
